import { render, staticRenderFns } from "./DataFileView.vue?vue&type=template&id=67e6c188"
import script from "./DataFileView.vue?vue&type=script&lang=ts"
export * from "./DataFileView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports